module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="gut-check__description">\n    <p>\n        Provide some background for how you got your ' +
__e( skillName ) +
' experience:\n    </p>\n    <textarea name="description">' +
__e( description ) +
'</textarea>\n    <div class="help-block" style="display: none">Please provide some background</div>\n</div>\n<footer>\n    <button class="btn btn-secondary btn-large js-back">Go Back</button>\n    <button class="btn btn-primary btn-large js-next">Next</button>\n</footer>\n';

}
return __p
}